import { SnackbarApiErrorMessage } from '@ui-framework/index';
import { getCurrentAddress } from '@product-framework/components/FormFields/ValidatedAddress';

const postProcessedAddressApiData = data => {
  const completeAddress = getCurrentAddress({
    address: data?.address,
    city: data?.city,
    state: data?.state?.name,
    country: data?.country?.countryName,
    zip: data?.postalCode,
    id: data?.id || null,
  });
  return {
    businessAddress: completeAddress,
  };
};

const fetchLocation = async params => {
  const url = `${params.getApiUrl()}/sxcl/v1/service-providers/${params.serviceProviderId}/locations/${params.pageId}`;
  const response = await params.get(url);
  if (response?.ok) {
    return response.data;
  }
  params.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return null;
};

const fetchContact = async params => {
  const url = `${params.getApiUrl()}/sxcl/v1/service-providers/${params.serviceProviderId}/contacts?locationId=${params.pageId}&contactType=MAIN&limit=1`;
  const response = await params.get(url);
  if (response?.ok) {
    return response.data;
  }
  params.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return null;
};

const fetchAddress = async (params, fullResponse) => {
  const url = `${params.getApiUrl()}/sxcl/v1/service-providers/${params.serviceProviderId}/addresses/?locationId=${params.pageId}`;
  const response = await params.get(url);
  if (response?.ok) {
    if (fullResponse) {
      return response;
    }
    return response.data;
  }
  params.snackbar.showMessage({
    type: 'error',
    data: <SnackbarApiErrorMessage errors={response?.errors} />,
  });
  return null;
};

const destructLocation = data => {
  const { id = null, ...rest } = data;
  return {
    locationId: id,
    ...rest,
  };
};

const editLocation = async (params, data) => {
  const url = `${params.getApiUrl()}/sxcl/v1/service-providers/${params.serviceProviderId}/locations/${params.pageId}`;
  const requestData = {
    locationName: data?.locationName,
    locationNumber: data?.locationNumber,
    status: data?.status,
    isDefaultLocation: data?.isDefaultLocation === true,
    serviceTravelDistance: data?.serviceTravelDistance,
  };
  const response = await params.put(url, requestData);
  return response;
};

const changeLocationStatus = async (params, data) => {
  const url = `${params.getApiUrl()}/sxcl/v1/service-providers/${params.serviceProviderId}/locations/${params.pageId}`;
  const requestData = {
    status: data?.status,
  };
  const response = await params.put(url, requestData);
  return response;
};

const editSPContact = async (params, data) => {
  const contactId = data?.mainContact?.id;
  let url = `${params.getApiUrl()}/sxcl/v1/service-providers/${params.serviceProviderId}/contacts`;

  const requestData = {
    userId: data?.mainContact?.user?.id,
    recordVersion: data?.mainContact?.recordVersion,
    ...(!contactId && {
      locationId: params.pageId,
      contactType: 'MAIN',
      isPrimary: true,
    }),
  };

  let response;

  if (contactId) {
    url = `${url}/${contactId}`;
    response = await params.put(url, requestData);
  } else {
    response = await params.post(url, requestData);
  }

  return response;
};

const editSPAddress = async (params, data, formRef) => {
  const defaultValues = formRef.current.getDefaultValues();
  const addressId = defaultValues.fullAddressData?.id;
  let url = `${params.getApiUrl()}/sxcl/v1/service-providers/${params.serviceProviderId}/addresses`;

  let requestData = {};

  if (
    defaultValues?.businessAddress?.address !== data?.businessAddress?.address
  ) {
    requestData = {
      addressType: defaultValues?.fullAddressData?.addressType || 'MAIN',
      placeId: data?.businessAddress?.id,
      placeSessionToken: data?.businessAddressSessionToken,
      location: {
        id: params.pageId,
      },
    };
    let response;
    if (addressId) {
      url = `${url}/${addressId}`;
      response = await params.put(url, requestData);
    } else {
      response = await params.post(url, requestData);
    }
    return response;
  }

  const noChangeResponse = {
    ok: true,
    data: defaultValues?.fullAddressData,
  };

  return noChangeResponse;
};

const getStatusButton = (params, currentStatus, IconLibrary) => {
  const currentStatusIsActive = currentStatus === 'ACTIVE';
  return {
    Icon: currentStatusIsActive ? IconLibrary.SPInActive : IconLibrary.SPActive,
    text: currentStatusIsActive
      ? params?.formatMessage({
          id: 'SERVICEPROVIDER_EDIT_ACTIVE_INACTIVE_BUTTON',
          defaultMessage: 'Set as In-Active',
        })
      : params?.formatMessage({
          id: 'SERVICEPROVIDER_EDIT_ACTIVE_ACTIVE_BUTTON',
          defaultMessage: 'Set as Active',
        }),
  };
};

export {
  getStatusButton,
  fetchLocation,
  fetchContact,
  fetchAddress,
  destructLocation,
  editLocation,
  editSPContact,
  editSPAddress,
  changeLocationStatus,
  postProcessedAddressApiData,
};
